/**
 * Pending-approval Employee Activity columns.
 * Set to false (or delete usages) to hide these fields from SA + Admin UIs quickly.
 */
export const SHOW_PENDING_EMPLOYEE_ACTIVITY_COLUMNS = false;

/** Manage-field / check keys for pending columns */
export const PENDING_EMPLOYEE_ACTIVITY_COLUMN_KEYS = [
  "lastBookCompletion",
  "lastApprovedTask",
  "unseenNotifications",
  "avgBookCompletionDays",
  "badgesEarned",
];

export const PENDING_EMPLOYEE_ACTIVITY_FIELD_LIST = [
  {
    name: "lastBookCompletion",
    label: "Last Book Completion Date (New)",
  },
  {
    name: "lastApprovedTask",
    label: "Last Approved Task Date (New)",
  },
  {
    name: "unseenNotifications",
    label: "Unseen Notifications Count (New)",
  },
  {
    name: "avgBookCompletionDays",
    label: "Avg Book Completion Days (New)",
  },
  {
    name: "badgesEarned",
    label: "Badges Earned (New)",
  },
];

export const PENDING_EMPLOYEE_ACTIVITY_CHECK_DEFAULTS = {
  lastBookCompletion: true,
  lastApprovedTask: true,
  unseenNotifications: true,
  avgBookCompletionDays: true,
  badgesEarned: true,
};

export const formatAvgBookCompletionDays = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return `${Number(value).toFixed(1)} days`;
};
